import { ReactNode } from 'react';

import { BodyText } from '../../../typography/BodyText';

import { Overview } from '../Overview';
import { WhatIsIncluded } from '../WhatIsIncluded';
import { AdditionalDetails } from '../AdditionalDetails';

// types
import type { InfoText } from '@virginexperiencedays/products';

const COLLECTION_DESCRIPTION_NAME = 'choice vouchers long description - pre-sale only';
const HOW_IT_WORKS_NAME = 'how it works';

type ProductOverviewProps = {
  isCollectionProduct?: boolean;
  description: string;
  whatsIncludedRef: any;
  whatsIncluded: string;
  texts: InfoText[];
  isWhatsIncludedVisible: boolean;
  experienceSummaryComponent?: ReactNode;
};

export const ProductOverview = ({
  isCollectionProduct = false,
  description,
  whatsIncluded,
  whatsIncludedRef,
  texts,
  isWhatsIncludedVisible,
  experienceSummaryComponent,
}: ProductOverviewProps) => {
  const overview = isCollectionProduct
    ? texts?.find((t) => t?.name?.toLowerCase() === COLLECTION_DESCRIPTION_NAME)?.content
    : description;
  return (
    <>
      {overview && (
        <Overview heading="Overview" headingSEOOverride="h2">
          <BodyText
            className="[&_>_p]:my-4"
            as="div"
            dangerouslySetInnerHTML={{ __html: overview }}
          />
          {experienceSummaryComponent ?? null}
        </Overview>
      )}
      {isCollectionProduct ? (
        <CollectionProductOverview texts={texts} />
      ) : (
        <DefaultProductOverview
          whatsIncluded={whatsIncluded}
          whatsIncludedRef={whatsIncludedRef}
          isWhatsIncludedVisible={isWhatsIncludedVisible}
          texts={texts}
        />
      )}
    </>
  );
};

// overview component for non-collection products
const DefaultProductOverview = ({
  whatsIncluded,
  whatsIncludedRef,
  isWhatsIncludedVisible,
  texts,
}: Partial<ProductOverviewProps>) => {
  return (
    <>
      <div ref={whatsIncludedRef}>
        <WhatIsIncluded className="my-8" content={whatsIncluded} />
      </div>
      <AdditionalDetails texts={texts} isPreviousVisible={isWhatsIncludedVisible} />
    </>
  );
};

// overview component for collection products
const CollectionProductOverview = ({ texts }: Partial<ProductOverviewProps>) => {
  // only grab How It Works. extend similarly to AdditionalDetails if needed
  const howItWorks = texts?.find((t) => t?.name?.toLowerCase() === HOW_IT_WORKS_NAME);

  return (
    <>
      {howItWorks && (
        <Overview key={howItWorks.name} heading={howItWorks.name} headingSEOOverride="h2">
          <BodyText as="div" dangerouslySetInnerHTML={{ __html: `${howItWorks.content}` }} />
        </Overview>
      )}
      <BodyText>
        <br />
        All images shown are for illustration purpose only, actual product may vary from images
        shown.
      </BodyText>
    </>
  );
};
